import { AI_CREDITS_EXHAUSTED } from '@flintmint/core-shared/constants';

/**
 * The app's own message for a `userSources.error` code, short for rows and headers, long for the processing view.
 * Undefined for any other error, which keeps each screen's generic failure text.
 */
export const getUserSourceErrorMessage = (error: string | null | undefined, form: 'short' | 'long'): string | undefined =>
  error === AI_CREDITS_EXHAUSTED ? aiCreditsExhaustedMessages[form] : undefined;

const aiCreditsExhaustedMessages = {
  short: 'AI Energy used up',
  long: 'Your AI Energy is used up. Resync this Blueprint when you have Energy again.',
};
